import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="w-full rounded-2xl border-2 border-danger/30 bg-danger-soft p-4" data-id="element-35" data-mp="2l5ppm8bj0cdm">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold text-danger" data-id="element-36" data-mp="2q3hfkwsm1of6">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="2b6gwtised3su" />
        Only {SPOTS_LEFT} spots left at the launch price
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-38" data-mp="2g74o85kjfmnl">
        <div className="bar-stripes flex h-full items-center justify-end rounded-full bg-danger pr-2" style={{
        width: `${filled}%`
      }} data-id="element-39" data-mp="efdhxx4itjd">
          <span className="text-[11px] font-bold text-white" data-id="element-40" data-mp="5d0gu67o9tc1">{Math.round(filled)}% claimed</span>
        </div>
      </div>
      <p className="mt-2 text-center text-xs font-medium text-ink/70" data-id="element-41" data-mp="33kihllmlbyin">
        When these spots are gone, the price goes back to regular value.
      </p>
    </div>;
}